// extracted by mini-css-extract-plugin
module.exports = {"intro":"Products_intro__3Nn8k","right":"Products_right__2rDKI","left":"Products_left__3SbPJ","leftword":"Products_leftword__2tSfD","rightword":"Products_rightword__3ORV4"};